import type { ReactNode } from "react";

interface FieldSectionProps {
  title: string;
  badge?: string;
  badgeLabel?: string;
  tone?: "attack" | "defense" | "gold";
  children: ReactNode;
}

export function FieldSection({
  title,
  badge,
  badgeLabel = "合计",
  tone = "gold",
  children,
}: FieldSectionProps) {
  return (
    <details className={`field-section ${tone}`}>
      <summary>
        <span>
          <strong>{title}</strong>
        </span>
        {badge && (
          <em className="section-total">
            <small>{badgeLabel}</small>
            <strong>{badge}</strong>
          </em>
        )}
      </summary>
      <div className="field-grid">{children}</div>
    </details>
  );
}
